import { combineReducers } from 'redux';
import collections from './collections';
import global from './global';

export default combineReducers({
    collections,
    global,
});
